import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Tripadviser from '../../assets/images/tripadviser.png'
import Jet2holidays from '../../assets/images/jet2holidays.png'


function Main() {

  const [ytshow, setytShow] = useState(false);

  return (
    <>
      <footer>
        <div className="container">
          <div className="foote_widget contact_info">
            <div className="row py_50">
              <div className="col-md-7 direction_block">
                <p>
                Hisaronu Mahallesi Oludeniz Beldesi, <br />
                Fethiye / Muğla<br />
                  Booking : <Link to="tel:+902526166361">+90 252 616 63 61</Link>
                </p>
                <Link to="https://www.google.com/maps/dir//The+Olive+Tree+Studios+%C3%96l%C3%BCdeniz+Cumhuriyet+Cd.+No+53+48300+Fethiye%2FMu%C4%9Fla/@36.5716414,29.1305389,14z/data=!4m8!4m7!1m0!1m5!1m1!1s0x14c042d844002779:0x4e0f75f7b6e9e7db!2m2!1d29.1305389!2d36.5716414?entry=ttu" className="btn_text">
                  get direction <i className="icofont-long-arrow-right" />
                </Link>
              </div>
              <div className="col-md-5 text-md-right timing_block">
                <p>
                  Monday - Sunday : 12PM - 00AM <br />
                </p>
                <Link to="/reservation1" className="btn btn_primary mt-3" id="bookingForm_modelTitle" data-toggle="modal" data-target="#bookingForm_model" onClick={() => 
               // setytShow(true)
               null}
                >
                  book a table
                </Link>
              </div>
            </div>
          </div>
          <div className="foote_widget newsletter_block">
            <div className="row py_50">
            {/*   <div className="col-md-7 offer_block">
                <h2>Get News &amp; Offers</h2>
                <p>
                  Subscribe us &amp; Get <span>25% Off.</span>
                </p>
                <form>
                  <div className="form-group">
                    <span className="icon position-absolute">
                      <i className="icofont-envelope-open" />
                    </span>
                    <input type="text" placeholder="Your email" className="form-control" required="" />
                    <button className="btn btn_primary">subscribe now</button>
                  </div>
                </form>
              </div> */}
              <div className="col-md-4">
                <ul className="social_media">
                  <li>
                    <a href="https://www.facebook.com/theolivetreerestaurantandbar" target='_blank'>Facebook</a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/theolivetreestudioss/?hl=tr" target='_blank'>Instagram</a>
                  </li>
                  <li>
                    <a href="https://twitter.com/" target='_blank'>Twitter</a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/watch?v=zIOt1faGd7g" target='_blank'>Youtube</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4 offer_block">
                                <div className="widget newsletter-widget">
                                    <div className="widget-title">
                                        <p>Tripadvisor</p>
                                    </div>
                                    <div className="logo widget-title">
                                    <a href="https://www.tripadvisor.com.tr/Restaurant_Review-g609055-d1177537-Reviews-The_Olive_Tree_Restaurant_Bar-Hisaronu_Oludeniz_Mugla_Province_Turkish_Aegean_Coa.html">
                                    <img src={Tripadviser}
                                    alt="tripadviser-olive-studio"
                                    height={100}
                                    width={100}
                                    />
                                    </a>
                                </div>
                                </div>
                
              </div>
              <div className="col-md-4 offer_block">
                                <div className="widget newsletter-widget">
                                    <div className="widget-title">
                                        <p>Jet2holidays</p>
                                    </div>
                                    <div className="logo widget-title">
                                    <a href="https://www.jet2holidays.com/turkey/dalaman-area/hisaronu/olive-tree-studios">
                                    <img src={Jet2holidays} 
                                    alt="tripadviser-olive-studio"
                                    height={150}
                                    width={100}
                                    />
                                    </a>
                                </div>
                                </div>
                
              </div>

            </div>
          </div>
          <div className="foote_widget menu_links">
            <div className="row">
              <div className="col-md-12">
                <ul className="links d-flex justify-content-center">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/menulist1">Menu</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
             {/*      <li>
                    <Link to="/ourchef">Our chefs</Link>
                  </li> */}
                  <li>
                    <Link to="/bloglist">Blog</Link>
                  </li>
                  <li>
                    <Link to="/gallery">Gallery</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 copy_right text-center">
              <p>
                © 2024 Fluxesoft. All Rights Reserved | Developed by{" "}
                <Link to="https://fluxesoft.com" target="blog-list" >
                  Fluxesoft
                </Link>
              </p>
            </div>
          </div>
        </div>
        <div className="go_top" id="Gotop">
          <span>
            <i className="icofont-rounded-up" />
          </span>
        </div>
      </footer>
      {ytshow &&
        <div className="modal fade booking_model show" id="bookingForm_model" tabIndex={-1} aria-labelledby="bookingForm_modelTitle" style={{ display: "block", paddingRight: 17 }} aria-modal="true" role="dialog" >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header text-center border-0 d-block p-0">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setytShow(false)}>
                  <span aria-hidden="true">
                    <i className="icofont-close-line" />
                  </span>
                </button>
                <h2 className="mb-2">Online Reservation</h2>
                <p>
                  Booking request <a href="tel:+902526166361">+90 252 616 63 61</a> or fill
                  out the order form
                </p>
              </div>
              <div className="modal-body">
                <div className="booking_form">
                  <form>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input type="text" className="form-control" placeholder="Your Name" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input type="text" className="form-control" placeholder="Phone Number" />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <span className="icon">
                            <i className="icofont-user-alt-7" />
                          </span>
                          <input type="text" className="form-control has_icon" placeholder="1 Person" />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <span className="icon">
                            <i className="icofont-calendar" />
                          </span>
                          <input type="date" className="form-control  flex-row-reverse" />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <span className="icon">
                            <i className="icofont-clock-time" />
                          </span>
                          <input type="time" className="form-control has_icon  flex-row-reverse pl-0"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder="Message"
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button className="btn btn_primary w-100 ">book a table</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default Main